import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-release-note-dialog',
  templateUrl: './release-note-dialog.component.html',
  styleUrls: ['./release-note-dialog.component.scss'],
})
export class ReleaseNoteDialogComponent {
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {}
}
